import { ResourceContextProvider, SimpleForm, Title, useNotify, useRedirect, useRefresh } from "react-admin";
import { CURRICULUMS, StudentServicePath, TOPICS } from "utils/constants";
import BackButtonToolbar from "features/BackButtonToolbar";
import { useLocation, useParams } from "react-router-dom";
import CreateForm from "./CreateForm";
import dataProvider from "server/dataProvider";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { studentRequests } from "api/studentApi";
import { useNotifyError } from "utils/useNotifyError";

const CreateTopics = () => {
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notifyError = useNotifyError();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const location = useLocation();
  const excludeIds = location?.state?.excludeIds;

  const { id } = useParams();

  const handleSubmit = async data => {
    const allTopics = Object.keys(data).reduce((acc, key) => {
      if (key.startsWith("topics_semester_") && Array.isArray(data[key])) {
        const semesterNumber = Number(key.replace("topics_semester_", ""));

        const validSemesterTopics = data[key]
          .filter(topic => topic && (topic.topicNameBg?.trim() || topic.topicNameEn?.trim()))
          .map(topic => ({
            semester: semesterNumber,
            weekNumber: topic.weekNumber,
            topicNameBg: topic.topicNameBg,
            topicNameEn: topic.topicNameEn,
            isColloquium: !!topic.isColloquium,
          }));

        return acc.concat(validSemesterTopics);
      }
      return acc;
    }, []);

    if (allTopics.length === 0) {
      notify("Моля, добавете поне една валидна тема", { type: "warning" });
      return;
    }

    const payload = {
      curriculumId: Number(id),
      disciplineId: data.disciplineId,
      academicYearId: data.academicYearId,
      ...(data.moduleId ? { moduleId: data.moduleId } : {}),
      topics: allTopics,
    };

    try {
      await dataProvider.customRequest(studentRequests.createCurriculumTopic(), payload, "POST");

      notify("Успешно създаване на тема за учебен план", { type: "success" });
      refresh();
      redirect(-1);
    } catch (err) {
      notifyError(err);
      handleConflictError(err);
    }
  };

  return (
    <>
      <Title title="Създай тема" />
      <BackButtonToolbar />
      <ResourceContextProvider value={`${StudentServicePath}${TOPICS}/${CURRICULUMS}/${id}/create`}>
        <SimpleForm
          onSubmit={handleSubmit}
          defaultValues={{ curriculumId: id }}
        >
          <CreateForm
            id={id}
            excludeIds={excludeIds}
          />
        </SimpleForm>
      </ResourceContextProvider>
      <ConflictErrorDialog />
    </>
  );
};

export default CreateTopics;
